export default __webpack_public_path__ + "static/media/pantry1-afterG-1920w.ccae7b6b.png";